<template>
<div container--fluid>
    <v-layout>
        <ClassesModule></ClassesModule>
    </v-layout>
</div>
</template>

<script>
import ClassesModule from '@modules/classes/index.vue';

export default {
    name: 'classes',
    components: {
        ClassesModule,
    },
    data(){
        return {
            //
        }
    },
    beforeCreate() {

    }
};
</script>

<style scoped>

</style>
